import 'intersection-observer'
import * as React from 'react'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { Media } from '../../../../cms/blocks/utils/media.mod'
import { ImageContainer } from '../../../../cms/blocks/widgets/ImageContainer.gen'
import { ParsedMediaImage, ParsedMediaVideo } from '../../../../drupal/types_and_parser/types'
import { CMSState } from '../../../drupalPage/state'

export type mediaBlockProps = {
  blockIndex: number
  media: ParsedMediaImage | ParsedMediaVideo
  caption?: string
  background?: 'grey' | 'white' | 'orange'
  useCookieBar: boolean
  cookiePlaceholder: JSX.Element | string
  cookieButton: string
  get_default_data_src: () => ImageSize
  get_default_data_srcset: () => [ImageSize, string][]
}

export type MediaBlockStyle = Partial<{
  block_classname: string
  media_classname: string
  visual_classname: string
  image_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  placeholder_classname: string
}>

export function mediaBlock(
  props: mediaBlockProps,
  options?: { style: MediaBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX((_) => {
      return (
        // <figure className={`block block--media${props.background == 'grey' ? " block--color" : props.background == 'orange' ? " block--orange" : ""}`}>
        <figure className={`block block--media mediablock-mod`}>
          <div className="block__inner container container--s grid--block">
            <div className="block__media">
              {props.media != null && props.media.bundle === 'image' ? (
                s.images.has(props.media.field_media_image.image.id) ? (
                  <div className={getClassName(options, 'media_classname', '')}>
                    {ImageContainer(
                      s.images.get(props.media.field_media_image.image.id),
                      'media',
                      getClassName(options, 'image_classname', 'w-100'),
                      props.media.field_media_image.alt,
                      props.get_default_data_src,
                      props.get_default_data_srcset
                    ).run((_) => {})}
                  </div>
                ) : (
                  <div className={getClassName(options, 'placeholder_classname', '')} aria-hidden="true"></div>
                )
              ) : (
                props.media != undefined &&
                props.media.bundle === 'video' && (
                  <div className={getClassName(options, 'media_classname', 'text-center')}>
                    <Media
                      kind="media"
                      useCookiebar={props.useCookieBar}
                      url={props.media.field_media_video_embed_field.value}
                    />
                  </div>
                )
              )}
            </div>
            {props.caption && (
              <figcaption className="block__figcaption media__figcaption">
                <p className="media__caption text--s">{props.caption}</p>
              </figcaption>
            )}
          </div>
        </figure>
      )
    })
}
